// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Forge Casino — Leaderboard
// Top winners, tournament standings
// ================================================================
import React, { useState } from 'react';

// Demo leaderboard data — will be from Supabase in production
const DEMO_LEADERS = [
  { rank: 1, name: 'ForgeKing', wins: 15420.50, spins: 2340, badge: '🥇' },
  { rank: 2, name: 'LuckyHammer', wins: 12100.00, spins: 1890, badge: '🥈' },
  { rank: 3, name: 'DiamondForge', wins: 9875.25, spins: 1560, badge: '🥉' },
  { rank: 4, name: 'AnvilStrike', wins: 7650.00, spins: 1234, badge: '' },
  { rank: 5, name: 'GoldRush99', wins: 6420.75, spins: 987, badge: '' },
  { rank: 6, name: 'StarPlayer', wins: 5100.00, spins: 876, badge: '' },
  { rank: 7, name: 'CherryBomb', wins: 4200.50, spins: 654, badge: '' },
  { rank: 8, name: 'BarRunner', wins: 3100.00, spins: 543, badge: '' },
  { rank: 9, name: 'ForgeNova', wins: 2450.25, spins: 432, badge: '' },
  { rank: 10, name: 'HammerTime', wins: 1900.00, spins: 321, badge: '' },
];

export default function Leaderboard() {
  const [period, setPeriod] = useState('daily');

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🏆 LEADERBOARD</h1>

      {/* Period selector */}
      <div style={styles.periods}>
        {['daily', 'weekly', 'monthly', 'all-time'].map(p => (
          <button key={p} style={{ ...styles.periodBtn, background: period === p ? '#DC2626' : '#1a1a1a', color: period === p ? '#fff' : '#888' }}
            onClick={() => setPeriod(p)}>{p.toUpperCase()}</button>
        ))}
      </div>

      {/* Top 3 */}
      <div style={styles.topThree}>
        {DEMO_LEADERS.slice(0, 3).map(leader => (
          <div key={leader.rank} style={{ ...styles.topCard, borderColor: leader.rank === 1 ? '#FFD700' : leader.rank === 2 ? '#C0C0C0' : '#CD7F32' }}>
            <span style={styles.topBadge}>{leader.badge}</span>
            <span style={styles.topName}>{leader.name}</span>
            <span style={{ ...styles.topWins, color: leader.rank === 1 ? '#FFD700' : '#00FF88' }}>
              ${leader.wins.toLocaleString()}
            </span>
            <span style={styles.topSpins}>{leader.spins} spins</span>
          </div>
        ))}
      </div>

      {/* Full list */}
      <div style={styles.list}>
        {DEMO_LEADERS.map(leader => (
          <div key={leader.rank} style={styles.listRow}>
            <div style={styles.rankBadge}>
              {leader.badge || `#${leader.rank}`}
            </div>
            <span style={styles.listName}>{leader.name}</span>
            <span style={styles.listSpins}>{leader.spins} spins</span>
            <span style={styles.listWins}>${leader.wins.toLocaleString()}</span>
          </div>
        ))}
      </div>

      <div style={styles.footer}>
        <p style={styles.footerText}>Rankings update in real-time. All results are provably fair.</p>
      </div>
    </div>
  );
}

const styles = {
  container: { padding: 16, maxWidth: 600, margin: '0 auto', minHeight: '100vh', background: '#0a0a0a' },
  title: { fontSize: 20, fontWeight: 900, color: '#fff', letterSpacing: 2, marginBottom: 16 },
  periods: { display: 'flex', gap: 4, marginBottom: 20 },
  periodBtn: { padding: '5px 10px', borderRadius: 4, border: '1px solid #333', fontSize: 9, fontWeight: 700, letterSpacing: 1, cursor: 'pointer' },
  topThree: { display: 'flex', gap: 8, marginBottom: 20 },
  topCard: {
    flex: 1, padding: 16, background: '#111', borderRadius: 12, border: '2px solid',
    textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 4,
  },
  topBadge: { fontSize: 28 },
  topName: { fontSize: 12, color: '#fff', fontWeight: 900 },
  topWins: { fontSize: 14, fontWeight: 900, fontFamily: "'Courier New', monospace" },
  topSpins: { fontSize: 9, color: '#555' },
  list: { background: '#111', borderRadius: 12, border: '1px solid #222', overflow: 'hidden' },
  listRow: {
    display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
    borderBottom: '1px solid #1a1a1a',
  },
  rankBadge: {
    width: 30, textAlign: 'center', fontSize: 14, fontWeight: 900, color: '#888',
  },
  listName: { flex: 1, fontSize: 12, color: '#fff', fontWeight: 700 },
  listSpins: { fontSize: 10, color: '#555' },
  listWins: { fontSize: 13, fontWeight: 900, color: '#00FF88', fontFamily: "'Courier New', monospace" },
  footer: { textAlign: 'center', padding: '20px 0' },
  footerText: { fontSize: 10, color: '#444' },
};
